import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import { Button, Grid, TextField } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";

import { useForm } from "../../../../hooks/useForm";
import { validarSoloUnPermiso } from "../../../../helpers/permisos";
import { Autocomplete } from "@material-ui/lab";
import { fetchConToken } from "../../../../helpers/fetch";
import {  TIPO_EFECTORES } from "../../../../utils/constants";
import { fetchSubTipoEfectores } from "../../../../actions/tipoSubtipoEfectores";

const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

const fechaActual = new Date();

export const FormIngresoPrestadoresRestringidos = (props) => {

  const classes = useStyles();
  const { formData, permisoEdit, permisoAlta } = props;
  const { permisos: permisosUser } = useSelector(state => state.auth);
  const { subtipoEfectores } = useSelector(
    (state) => state.tipoSubtipoEfectores
  );

  const dispatch = useDispatch();
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);



  const formInit = {
    descripcion: ""
  }

  const [formValues, handleInputChange ] = useForm(formData ? formData : formInit);

  const handleSave = (e) => {
    e.preventDefault()
    console.log("efector", value)
    props.handleSave(formValues, value);
  };



  //BUSCADOR CONTRATACIONES
  const nuevo = false;
  const idTipoEfector = TIPO_EFECTORES.CONTRATO_PRESTADORES;

  useEffect(() => {
    dispatch(fetchSubTipoEfectores());
  }, []);

  useEffect(() => {
    let active = true;
    setLoading(true);

    if (inputValue === '') {
      setOptions(value ? [value] : []);
      setLoading(false);
      return undefined;
    }

    (async () => {
      const response = await fetchConToken(`EfectorFacturacion/BusquedaPorIdTipoEfector/${idTipoEfector}?parametros=${inputValue}&nuevo=${nuevo}`);
      const results = await response.json();

      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        newOptions = [...newOptions, ...results];

        setOptions(newOptions);
        setLoading(false);
      }

    })();
    return () => {
      active = false;
    };
  }, [value, inputValue]);


  return (
    <ValidatorForm onSubmit={handleSave}>
      <Grid container style={{ padding: 25 }}>
        <Grid item xs={12} md={12}>
          <Autocomplete
            style={{ marginTop: "1rem" }}
            disabled={!idTipoEfector}
            filterOptions={(x) => x}
            options={options}
            autoComplete
            includeInputInList
            filterSelectedOptions
            value={value}
            onChange={(event, newValue) => {
              setOptions(newValue ? [newValue, ...options] : options);
              setValue(newValue);
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            noOptionsText="No hay contrato"
            loadingText="Buscando..."
            loading={loading}
            getOptionLabel={(option) => {
              const subTipoEfector = subtipoEfectores.find(
                (subTipoEfector) =>
                  subTipoEfector.idSubTipoEfector ===
                  option.idSubTipoEfector
              )?.descripcionSubTipoEfector;
              return `${option.razonSocial} ${option.cuit} - ${subTipoEfector}`;
            }}
            renderOption={(option) => {
              const subTipoEfector = subtipoEfectores.find(
                (subTipoEfector) =>
                  subTipoEfector.idSubTipoEfector ===
                  option.idSubTipoEfector
              )?.descripcionSubTipoEfector;
              return (
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span
                    style={{
                      color: option.fechaBaja === null || option.fechaBaja >= fechaActual.toISOString() ? "green" : "red",
                    }}
                  >{`${option.razonSocial} ${option.cuit} - ${subTipoEfector} -  ${option.efectorDomicilio?.calle} ${option.efectorDomicilio?.nro}`}</span>
                </div>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Cod contrato  |  CUIT  |  Razón Social  |  Nombre Fantasia"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextValidator
            margin="normal"
            label="Observacion"
            name="observaciones"
            value={formValues.observaciones}
            autoComplete="off"
            onChange={handleInputChange}
            fullWidth
            style={{ paddingRight: "0.5rem" }}
            validators={["required"]}
            errorMessages={["La descripción es requerida"]}
          />
        </Grid>

        <Grid container className={classes.botonera}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={1}
              direction="row"
              justify="flex-end"
              alignItems="center"
            >
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<CancelIcon />}
                onClick={props.cerrarModal}
              >
                CANCELAR
              </Button>
              {(validarSoloUnPermiso(permisosUser, permisoAlta) ||
                validarSoloUnPermiso(permisosUser, permisoEdit)) && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<SaveIcon />}
                    type="submit"
                    style={{ marginLeft: "0.5rem" }}
                  >
                    GUARDAR
                  </Button>
                )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ValidatorForm>
  )
}
